export const lightTheme = {
  colors: {
    paragraph: "#434242",
    info: "#909090",

    bg: "#FCFCFC",
    shape: "#F5F8FB",
  },
};
